import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
    BiCartAlt,
    BiLaptop,
    BiUserCircle
} from 'react-icons/bi';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';
import { useAppSelector } from 'hooks/useStore';
import './index.css';

function Hamburger({ transparent }: { transparent: boolean; }) {
    const [open, setOpen] = useState(false);

    const { user } = useAppSelector(state => state.user);
    const { organization } = useAppSelector(state => state.organization);
    const ref = useOutsideClickHandler(() => setOpen(false));

    return (
        <button className={
            open ? 'hamburger--open' : transparent ? 'hamburger--transparent' : 'hamburger'} 
            onClick={() => setOpen(!open)}
            ref={ref}
        >
            <div className='hamburger__top'></div>
            <div className='hamburger__mid'></div>
            <div className='hamburger__bot'></div>
            <div className={open ? 'hamburger__menu--open' : 'hamburger__menu'} ref={ref}>
                {/* App links are hidden until the student signs in — pre-login
                    these routes either redirect to /sign-in or don't exist. */}
                {user && <>
                {/* <NavLink
                    to='/courses'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Courses
                </NavLink> */}
                {/* <NavLink
                    to='/tests'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Tests
                </NavLink> */}
                {/* <NavLink
                    to='/tests/digital-act'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Digital ACT
                </NavLink>
                <NavLink
                    to='/tests/digital-sat'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Digital SAT
                </NavLink>
                <NavLink
                    to='/tests/digital-psat'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Digital PSAT
                </NavLink> */}
                <NavLink
                    to='/tests'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Tests
                </NavLink>
                <NavLink
                    to='/assignments'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Assignments
                </NavLink>
                {/* Vocab was added to the desktop navbar but missing from this
                    mobile menu — mobile students couldn't reach it. Gated by the
                    same 'Hide Vocab' customization as the desktop link. */}
                {!organization.customizations.find(customization => customization === 'Hide Vocab') &&
                    <NavLink
                        to='/vocab'
                        className={({ isActive }) => (
                            isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                        )}
                    >
                        Vocab
                    </NavLink>
                }
                {organization.customizations.find(customization => customization === 'Video Lectures') &&
                    <NavLink
                        to='/lectures'
                        className={({ isActive }) => (
                            isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                        )}
                    >
                        Lectures
                    </NavLink>
                }
                {user?.customizations?.includes('FillApp Enabled') &&
                    <NavLink
                        to='/college-apps'
                        className={({ isActive }) => (
                            isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                        )}
                    >
                        College Apps
                    </NavLink>
                }
                </>}
                {user
                    ?   <>
                            {/* <NavLink
                                to='/cart'
                                className={({ isActive }) => (
                                    isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                                )}
                            >
                                <BiCartAlt className='hamburger__menuItemIcon' />
                                My Cart
                                {(courses.length > 0 || tests.length > 0 || bundles.length > 0) && 
                                    <p className='hamburger__cartBadge'>{courses.length + tests.length + 
                                        bundles.reduce((count, bundle) => (
                                            count + (bundle.numRequired ? 0 : (bundle.courses.length + bundle.tests.length))
                                        ), 0)
                                    }</p>
                                }
                            </NavLink> */}
                            <NavLink
                                to='/account'
                                className={({ isActive }) => (
                                    isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                                )}
                            >
                                <BiUserCircle className='hamburger__menuItemIcon' />
                                Account
                            </NavLink>
                        </>
                    :   <NavLink
                            to='/sign-in'
                            className={({ isActive }) => (
                                isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                            )}
                        >
                            Sign In
                        </NavLink>
                }
            </div>
        </button>
    );
}

export default Hamburger;